var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstragram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_1007",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.666 6.66669H13.3327C9.65078 6.66669 6.66602 9.65146 6.66602 13.3334V26.6667C6.66602 30.3486 9.65078 33.3334 13.3327 33.3334H26.666C30.3479 33.3334 33.3327 30.3486 33.3327 26.6667V13.3334C33.3327 9.65146 30.3479 6.66669 26.666 6.66669Z",
    stroke: "url(#paint0_linear_1_1007)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 25C22.7614 25 25 22.7614 25 20C25 17.2386 22.7614 15 20 15C17.2386 15 15 17.2386 15 20C15 22.7614 17.2386 25 20 25Z",
    stroke: "url(#paint1_linear_1_1007)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 12.5V12.501",
    stroke: "url(#paint2_linear_1_1007)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1007",
    x1: 33.5988,
    y1: 6.40002,
    x2: 6.66601,
    y2: 33.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#E0314D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED754"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_1007",
    x1: 25.0998,
    y1: 14.9,
    x2: 15,
    y2: 25.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#E0314D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED754"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_1007",
    x1: 28.51,
    y1: 12.5,
    x2: 28.51,
    y2: 12.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#E0314D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED754"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstragram);
export default __webpack_public_path__ + "static/media/instragram.fb03df740939371621025d32c3c718fe.svg";
export { ForwardRef as ReactComponent };